"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotationAction = exports.ChargeCardStatus = exports.ProductColor = exports.ChargePointType = exports.ProductGroup = exports.cardType = exports.gender = exports.productType3 = exports.productType2 = exports.status = exports.productType = exports.mount_type = exports.reimbursementApplicable = exports.channel = exports.contact_log_type = exports.CaseInternalUpdateActions = exports.PhotoType = exports.ActionIDs = exports.EmobilityLeadSegmentType = exports.CustomerScenario = exports.ProductSelection = exports.ProductType = exports.ChargeCardType = exports.Gender = exports.ElectricityMainsValueType = exports.ChargingStationType = exports.ChargingStationColor = exports.GroundType = exports.CaseStates = exports.MeterGeneration = exports.MountType = exports.DutchBoolean = exports.CaseActionType = exports.QuotationUpdateActions = exports.EmailType = void 0;
exports.EmailType = {
    CHARGECARD: 'charge-card',
    ENRICHMENT: 'enrichment',
    ENRICHMENT_CONFIRMATION: 'enrichment-confirmation',
    ENRICHMENT_REMINDER: 'enrichment-reminder',
    QUOTATION: 'quotation',
    QUOTATION_APPROVED: 'quotation-approved',
    QUOTATION_EXPIRED: 'quotation-expired',
    QUOTATION_REMINDER: 'quotation-reminder',
    QUOTATION_SECOND_REMINDER: 'quotation-reminder2',
    QUOTATION_UPDATED: 'quotation-updated',
    INVOICE_NOTIFICATION: 'invoice-notification',
    NO_CONTACT: 'no-contact',
    LEAD_CONFIRMATION: 'lead-confirmation',
    REIMBURSEMENT_INITIAL: 'reimbursement-initial',
    REIMBURSEMENT_CONFIRMATION: 'reimbursement-confirmation'
};
exports.QuotationUpdateActions = {
    SubmitQuotationApproval: 'submit_quotation_approval_data',
    SubmitQuotationRejected: 'submit_quotation_rejected_data',
    ApproveDriverQuotation: 'submit_driver_approval',
    RejectDriverQuotation: 'quotation_rejected_by_driver'
};
exports.CaseActionType = {
    CallbackCustomer: 'CALLBACK_CUSTOMER',
    ReviewQuestionnaire: 'REVIEW_QUESTIONNAIRE',
    UploadQuotation: 'UPLOAD_QUOTATION',
    ActivateChargingStation: 'ACTIVATE_CHARGING_STATION',
    ActivateChargeCard: 'ACTIVATE_CHARGE_CARD'
};
exports.DutchBoolean = {
    True: 'Ja',
    False: 'Nee'
};
exports.MountType = {
    Pole: 'Paalmontage',
    Wall: 'Wandmontage'
};
exports.MeterGeneration = {
    GenerationOne: 'Ouder dan 2014, bouwen<2014',
    GenerationTwo: '2014 en nieuwer bouwen>=2014'
};
exports.CaseStates = {
    ProcessStarted: 'PROCESSSTARTED',
    ProcessFinalized: 'PROCESSFINALIZED',
    ProcessCancelled: 'PROCESSCANCELLED',
    ProcessAborted: 'PROCESSABORTED',
    WaitForAccountCreation: 'WAITFORACCOUNTCREATION',
    WaitForCallback: 'WAITFORCALLBACK',
    CallbackFailed: 'CALLBACKFAILED',
    WaitForDataCollection: 'WAITFORDATACOLLECTION',
    DataCollectionFailed: 'DATACOLLECTIONFAILED',
    WaitForQuotation: 'WAITFORQUOTATION',
    WaitForQuotationApproval: 'WAITFORQUOTATIONAPPROVAL',
    QuotationRejected: 'QUOTATIONREJECTED',
    WaitForCooldown: 'WAITFORCOOLDOWN',
    WaitForInstallation: 'WAITFORINSTALLATION',
    WaitForFulfilment: 'WAITFORFULFILMENT',
    WaitForLeaseQuotation: 'WAITFORLEASEQUOTATION',
    WaitForLeaseQuotationApproval: 'WAITFORLEASEAPPROVAL',
    WaitForDriverQuotation: 'WAITFORDRIVERQUOTATION',
    WaitForDriverApproval: 'WAITFORDRIVERAPPROVAL',
    QuotationVerification: 'QUOTATIONVERIFICATION'
};
exports.GroundType = {
    Clinker: 'Klinker',
    EarthSand: 'Aarde / Zand',
    OrnamentalPavementLarge: 'Sierbestrating / tegels > 50cm',
    OrnamentalPavementSmall: 'Sierbestrating / tegels < 50cm',
    GravelWithGravelMats: 'Grind op grindmatten',
    GravelOnRootClothOrSandySoil: 'Grind op worteldoek of zandbodem',
    PavingOnMixedRubbleGranulates: 'Bestrating op meng- of puingranulaat'
};
exports.ChargingStationColor = {
    White: 'Wit',
    Anthracite: 'Antraciet'
};
exports.ChargingStationType = {
    SLine: 's-line',
    ProLine: 'pro-line'
};
exports.ElectricityMainsValueType = {
    ONE: '1x25',
    TWO: '2x25',
    THREE: '3x25',
    FOUR: '4x25'
};
exports.Gender = {
    MALE: 'male',
    FEMALE: 'female',
    OTHER: 'other'
};
exports.ChargeCardType = {
    ChargeCard: 'ChargeCard',
    KeyFob: 'Druppel'
};
exports.ProductType = {
    ChargeCard: 'charge-card',
    ChargingStation: 'charge-station'
};
exports.ProductSelection = {
    CHARGING_STATION: 'particulier-laden',
    CHARGE_CARD: 'particulier-laadpas',
    CHARGING_STATION_REIMBURSEMENT: 'reimbursement-laden'
};
exports.CustomerScenario = {
    New: 'NEW_CUSTOMER',
    ExistingConsumer: 'EXISTING_CONSUMER',
    ExistingConsumerWithCard: 'EXISTING_CONSUMER_WITH_CARD',
    ExistingSoho: 'EXISTING_SOHO'
};
exports.EmobilityLeadSegmentType = {
    HH: 'household',
    SOHO: 'small_office_home_office'
};
exports.ActionIDs = {
    ProcessCustomerConfirmation: 'PROCESS_CUSTOMER_CONFIRMATION',
    ProcessCustomerCreation: 'PROCESS_CUSTOMER_CREATION',
    AbortStepFunction: 'ABORT_STEP_FUNCTION',
    SendEmail: 'SEND_EMAIL'
};
exports.PhotoType = {
    SmartMeter: 'smartMeter',
    FuseBox: 'fusebox',
    GroupBox: 'groupbox',
    InstallationSite: 'installationSite',
    CrawlSpace: 'crawlSpace',
    DiggingGroundType: 'digginggroundtype',
    DiggingGroundType2: 'digginggroundtype2',
    ExtraDocuments: 'extraDocuments'
};
exports.CaseInternalUpdateActions = {
    IntermittentSaveEnrichmentForm: 'save_questionnaire_data',
    SubmitRejectReview: 'submit_quotation_to_datacollection',
    SubmitQuotation: 'submit_quotation_data',
    SaveQuotationApproval: 'save_quotation_approval_data',
    SaveQuotation: 'save_quotation_data',
    UploadLeaseQuotation: 'submit_lease_quotation',
    SaveLeaseApproval: 'save_lease_approval',
    SaveDriverApproval: 'save_driver_approval',
    UploadDriverQuotation: 'submit_driver_quotation',
    SaveDriverQuotation: 'save_driver_quotation'
};
/**
 * The type of contactlog. Use contact_log if there has been interaction with the customer, and service_request if there was no interaction between Essent/Energiedirect and the customer.
 */
exports.contact_log_type = {
    CONTACT_LOG: 'contact_log',
    SERVICE_REQUEST: 'service_request'
};
/**
 * The channel to which how the contact has taken place
 */
exports.channel = {
    TELEPHONE: 'telephone',
    BRIEF: 'brief',
    RETURN_POST: 'returnpost',
    FAX: 'fax',
    FORMS: 'forms',
    MIJN_ESSENT: 'mijnessent_nl',
    MAIL_WEBFORM: 'e-mail_webform',
    VISIT: 'visit',
    EXTERN: 'extern',
    OPEN_ENV_WEBFORM: 'open_env_webform',
    CLOSED_ENV_WEBFORM: 'closed_env_webform',
    SOCIAL_MEDIA: 'social_media',
    INTERNAL_ADVICE: 'intern_advice',
    SMS: 'sms',
    CHAT: 'chat',
    TELEFONIEBOT: 'telefoniebot',
    CHATBOT: 'chatbot',
    PUSH_NOTIFICATION: 'pushnotification'
};
/**
 * reimbursement applicable
 */
exports.reimbursementApplicable = {
    TRUE: 'true',
    FALSE: 'false'
};
/**
 * The mount type of the charging station
 */
exports.mount_type = {
    Pole: 'Paalmontage',
    Wall: 'Wandmontage'
};
exports.productType = {
    CHARGE_CARD: 'ChargeCard'
};
exports.status = {
    ACTIVE: 'Active',
    BLOCKED: 'Blocked',
    WAIT_FOR_OCPI_ACTIVATION: 'WaitForOcpiActivation',
    INACTIVE: 'Inactive'
};
exports.productType2 = {
    CHARGE_POINT: 'ChargePoint'
};
exports.productType3 = {
    CHARGE_CARD: 'charge-card',
    CHARGE_STATION: 'charge-station'
};
exports.gender = {
    MALE: 'male',
    FEMALE: 'female',
    OTHER: 'other'
};
exports.cardType = {
    CHARGE_CARD: 'ChargeCard',
    DRUPPEL: 'Druppel'
};
exports.ProductGroup = {
    CHARGING_STATION: 'charging-station'
};
exports.ChargePointType = {
    SLine: 'sline',
    ProLine: 'proline'
};
exports.ProductColor = {
    Wit: 'wit',
    Antraciet: 'antraciet'
};
/**
 * Card status
 */
exports.ChargeCardStatus = {
    ACTIVE: 'Active',
    BLOCKED: 'Blocked',
    WAIT_FOR_OCPI_ACTIVATION: 'WaitForOcpiActivation',
    INACTIVE: 'Inactive',
    LINKED: 'Linked',
    AVAILABLE: 'Available'
};
exports.QuotationAction = {
    Approve: 'approve',
    Reject: 'reject'
};
